import request from '@/utils/zsm-requets'
let fund='/zsm/api/fund/'
let fundReport='/zsm/api/fundReport/'
/**
 *  个人资金信息
 *  id 用户账号id
 */
export function getFund(id) {
  return request({
    url: fund+'get',
    method: 'post',
    params: {id}
  })
}


/**
 *  讲师收益列表
 *  fee 收益金额
 *  distFlag 是否分销
 *  payFlag 是否支付
 *  withdrawFlag 提现状态
 *  bizId 订单号
 *  partnerId 用户
 */
export function incomeListFund(params) {
  return request({
    url: fund+'incomeList',
    method: 'post',
    params
  })
}



/* 提现 */
export function withdrawFund(params) {
  return request({
    url: fund+'withdraw',
    method: 'post',
    params
  })
}


/* 提现记录 */
export function withdrawList(params) {
  return request({
    url: fund+'withdrawList',
    method: 'post',
    params
  })
}

// 获取某人某天资金数据
export function getFundReport(params) {
  return request({
    url: fundReport+'get',
    method: 'post',
    params
  })
}


// 获取某人某个时间段内的数据
export function listDataFundReport(params) {
  return request({
    url: fundReport+'listData',
    method: 'post',
    params
  })
}
